import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild, inject } from '@angular/core';

import { FormControl, FormGroup } from '@angular/forms';
import { ViewConfig, ViewModes } from '@spartacus/storefront';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ViewportScroller } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentSpecificSearchService } from '../service/Document-specific/document-specific-search.service';
import { RecentSearchService } from '../service/Recent-Search/recent-search.service';
import { LanguageService, ProductSearchPage } from '@spartacus/core';
import { ProductListService } from '../service/Product-list/product-list.service';
@Component({
  selector: 'kbs-site-doc-search-page',
  templateUrl: './kbs-site-doc-search-page.component.html',
  styleUrl: './kbs-site-doc-search-page.component.scss',
  standalone: false
})
export class KbsSiteDocSearchPageComponent {

  productListService = inject(ProductListService);
  scrollConfig = inject(ViewConfig);
  private kbDocService = inject(DocumentSpecificSearchService);
  private viewportScroller = inject(ViewportScroller);
  private cdr = inject(ChangeDetectorRef);
  private bpo = inject(BreakpointObserver);
  private activatedroute = inject(ActivatedRoute);
  private recentSearch = inject(RecentSearchService);
  private langservice = inject(LanguageService);
  private router = inject(Router)

  ApiData: any;
  ApiDataSearch: any;
  isMobile: boolean = false;
  recentSearches: any[] = [];
  searchInput: string = '';

  isInfiniteScroll: boolean | undefined;
  defaultPageSize: any = 20;

  viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  ViewModes = ViewModes;

  currentPage!: number;
  pageSize!: number;
  sortKey!: string;

  private subsLang!: Subscription;
  private subsSearch!: Subscription;
  private subsForm!: Subscription;
  avoidPageLoadCall: boolean = false;
  changeFormData: boolean = false;
  //Document Search form

  docSearchForm = new FormGroup({
    searchKey: new FormControl(''),
    productCategory: new FormControl(null),
    docType: new FormControl(''),
    docProductGroup: new FormControl(),
  });
  /*  documentAddText: new FormControl(),
    documentSuppText: new FormControl(), */
  SearchQuery!: string;
  helightText!: string;

  get form() {
    return this.docSearchForm.controls;
  }

  @ViewChild('searchInput') searchInputDoc!: ElementRef;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsideComponent = (event.target as HTMLElement).closest('.docInputSearch');
    if (!clickedInsideComponent) {
      this.hideRecentSearches(); // Hide the dropdown when clicking outside the component
    }
  }

  updateRecentSearches(): void {
    this.recentSearches = this.recentSearch.getRecentSearches('DocRecentSearchBox');
  }

  onSearch(event: Event): void {
    //  event.preventDefault();
    this.recentSearch.saveRecentSearch(this.searchInput, 'DocRecentSearchBox');
    this.updateRecentSearches();
  }

  onSearchInput(event: any): void {
    this.searchInput = event.target.value;
    if (this.searchInput.length >= 1) {
      this.hideRecentSearches();
    } else {
      this.showRecentSearches();
    }
  }

  clearRecentSearch(): void {
    this.hideRecentSearches();
  }

  showRecentSearches(): void {
    const recentSearchPopup = document.querySelector('.RecentSearchDOCPopUP');
    if (recentSearchPopup) {
      recentSearchPopup.classList.add('show');
    }
  }

  hideRecentSearches(): void {
    const recentSearchPopup = document.querySelector('.RecentSearchDOCPopUP');
    if (recentSearchPopup) {
      recentSearchPopup.classList.remove('show');
    }
  }

  populateSearchInput(value: string): void {
    this.docSearchForm.controls['searchKey'].setValue(value);
    this.searchInputDoc.nativeElement.value = value;
    this.hideRecentSearches();
  }

  ngOnInit() {
    this.productListService.selectedTabIndex.next(7);
    this.avoidPageLoadCall = false;
    this.changeFormData = false;
    this.updateRecentSearches();
    this.reset();
    this.bpo.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
      this.isMobile = result.matches;
      if (this.isMobile) {
        this.setViewMode(this.ViewModes.Grid);
      } else {
        this.setViewMode(this.ViewModes.List);
      }
    });
    this.routePatcher();
    this.isInfiniteScroll = this.scrollConfig.view?.infiniteScroll?.active;
    this.formDataApiCaller();
  }

  ngAfterViewInit() {
    this.subsLang = this.langservice.getActive().subscribe((lang: any) => {
      if (this.avoidPageLoadCall) {
        this.search(this.currentPage, this.pageSize, this.sortKey);
        this.formDataApiCaller();
      } else if (this.changeFormData) {
        this.formDataApiCaller();
      }
    });
  }

  routePatcher() {
    this.activatedroute.queryParamMap.subscribe((params: any) => {
      if (params.get('text') || params.get('docType') || params.get('docCategory') || params.get('docLanguage')) {
        this.docSearchForm.controls.searchKey.setValue(params.get('text') || '');
        this.docSearchForm.controls.docType.setValue(params.get('docType') || null);
        this.docSearchForm.controls.productCategory.setValue(params.get('docCategory') || null);
        this.docSearchForm.controls.docProductGroup.setValue(params.get('docProductGroup') || null);
        //this.docSearchForm.controls.documentAddText.setValue(params.get('documentAddText') || null);
        //this.docSearchForm.controls.documentSuppText.setValue(params.get('documentSuppText') || null);
        this.search(0, 20, '');
      }
    });
    this.activatedroute.queryParams.subscribe((params: any) => {
      const canCallApi = (params && params?.banner) ? true : false;
      if (canCallApi) {
        this.docSearchForm.controls.docType.setValue('Up2Date');
        this.search(0, 20, '');
      }
    });
  }

  formDataApiCaller() {
    this.subsForm = this.kbDocService.getDocSearchPage().subscribe((data: any) => {
      this.ApiDataSearch = data;
      this.changeFormData = true;
      this.cdr.detectChanges();
    });
  }

  reset() {
    this.docSearchForm.reset();
    this.productListService.selectedTabIndex.next(0);
    this.productListService.seperateDocDetails$.next(null);
  }

  search(currentPage: any, pageSize: any, sort: string, model?: { currentQuery: { query: { value: any; }; }; } | undefined) {
    this.currentPage = currentPage;
    this.pageSize = pageSize;
    this.sortKey = sort;
    if (model) {
      this.SearchQuery = this.productListService.DecodeQuery(model?.currentQuery?.query?.value)
    }
    else {
      this.SearchQuery = this.form.searchKey.value ?? '';
      this.helightText = this.form.searchKey.value ?? '';
    }
    let ApiPayload = {
      searchKey: this.SearchQuery,
      productCategory: (this.form.productCategory.value === null || this.form.productCategory.value === 'null') ? '' : this.form.productCategory.value,
      docType: (this.form.docType.value === null || this.form.docType.value === 'null') ? '' : this.form.docType.value,
      docProductGroup: (this.form.docProductGroup.value === null || this.form.docProductGroup.value === 'null') ? '' : this.form.docProductGroup.value,
      //documentAddText: (this.form.documentAddText.value === null || this.form.documentAddText.value === 'null') ? '' : this.form.documentAddText.value,
      //documentSuppText: (this.form.documentSuppText.value === null || this.form.documentSuppText.value === 'null') ? '' : this.form.documentSuppText.value
    };
    this.router.navigate([], {
      queryParams: {
        text: this.form.searchKey.value ?? '',
        docType: ApiPayload.docType,
        docCategory: ApiPayload.productCategory,
        docProductGroup: ApiPayload.docProductGroup,
        //documentAddText: ApiPayload.documentAddText,
        //documentSuppText: ApiPayload.documentSuppText,
      },
      queryParamsHandling: 'merge',
    });
    this.subsSearch = this.productListService.getCustomDocumentDetails(ApiPayload, pageSize, currentPage, sort).subscribe((data: ProductSearchPage) => {
      this.productListService.seperateDocDetails$.next(data);
      this.productListService.selectedTabIndex.next(7);
      this.productListService.isDocpaginationClickEvent = false;
      this.avoidPageLoadCall = true;
      this.cdr.detectChanges();
    });
  }

  changePageSize(pageSize: any) {
    this.defaultPageSize = pageSize;
    this.search(0, pageSize, '');
  }

  changePage(page: number, model: any) {
    this.search(page, model.pagination.pageSize, model.pagination.sort, model);
  }

  sortList(e: string, model: any) {
    this.search(0, 20, e, model);
  }

  changePageCustom(currentPage: any, model: any) {
    this.viewportScroller.scrollToPosition([0, 200]);
    this.productListService.isDocpaginationClickEvent = true;
    this.search(currentPage, 20, model?.pagination?.sort, model);
  }

  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode);
  }

  ngOnDestroy() {
    this.avoidPageLoadCall = false;
    this.changeFormData = false;
    this.subsForm && this.subsForm.unsubscribe();
    this.subsSearch && this.subsSearch.unsubscribe();
    this.subsLang && this.subsLang.unsubscribe();
    this.reset();
  }
}